<template>
  <div class="take-interest d-flex align-items-end mt-3 mt-lg-0">
    <transition
      v-if="userId"
      name="fade"
      mode="out-in"
    >
      <p
        v-if="takenInterest"
        class="price--highlight"
        v-html="I18n.t('artworks.taken_interest')"
      />
      <p
        v-else-if="error"
        class="price--highlight"
      >
        {{ I18n.t('artworks.take_interest_error') }}
      </p>
      <button
        v-else
        @click="sendInformation"
        class="btn btn__default position-relative py-2 w-100"
        type="button"
        name="button"
      >
        {{ I18n.t('artworks.take_interest') }}
      </button>
    </transition>
    <a
      v-else
      class="btn btn__default position-relative py-2 w-100"
      :href="new_user_session_path"
    >
      {{ I18n.t('artworks.take_interest') }}
    </a>
  </div>
</template>

<script>
/* global Routes */
import { mapState } from 'vuex';

export default {
  name: 'TakeInterest',
  props: {
    artwork: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      new_user_session_path: Routes.new_user_session_path(),
      takenInterest: false,
      error: false,
      baseUrl: null,
    };
  },
  methods: {
    sendInformation() {
      this.$http({
        method: 'POST',
        url: `${this.baseUrl}/api/v1/artworks/${this.artwork.id}/take_interest`,
      }).then(() => {
        this.takenInterest = true;
      }).catch(() => {
        this.error = true;
      });
    },
  },
  computed: {
    ...mapState(['userId']),
  },
  mounted() {
    this.baseUrl = window.location.origin;
  },
};
</script>



// WEBPACK FOOTER //
// app/javascript/packs/shared/components/artwork_take_interest.vue?1589053c